/**
 * Bewaart advertentieparameters (utm's, fbclid) uit de landingspagina-URL,
 * zodat een conversie later aan de juiste advertentie gekoppeld kan worden.
 */

const STORAGE_KEY = "nc-ad-params";

export interface AdParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  fbclid?: string;
  landing_page?: string;
  ts?: number;
}

const KEYS: (keyof AdParams)[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
];

export function captureAdParams() {
  if (typeof window === "undefined") return;
  try {
    const search = new URLSearchParams(window.location.search);
    const found: AdParams = {};
    KEYS.forEach((k) => {
      const v = search.get(k);
      if (v) found[k] = v as never;
    });
    if (Object.keys(found).length === 0) return;
    found.landing_page = window.location.pathname;
    found.ts = Date.now();
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));

    // Meta klik-ID als _fbc cookie bewaren voor server-side matching
    if (found.fbclid) {
      const fbc = `fb.1.${Date.now()}.${found.fbclid}`;
      document.cookie = `_fbc=${fbc}; path=/; max-age=${60 * 60 * 24 * 90}; SameSite=Lax`;
    }
  } catch {
    /* opslag geblokkeerd */
  }
}

export function getAdParams(): AdParams {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as AdParams) : {};
  } catch {
    return {};
  }
}

export function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}
